import { render, staticRenderFns } from "./InputTes.vue?vue&type=template&id=45d2be19&scoped=true"
import script from "./InputTes.vue?vue&type=script&lang=js"
export * from "./InputTes.vue?vue&type=script&lang=js"
import style0 from "./InputTes.vue?vue&type=style&index=0&id=45d2be19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2be19",
  null
  
)

export default component.exports